<template>
  <div class="isSoldOut_container border-radius-8" :style="customStyle">
    <div v-show="isSold" :class="soldImgSize">
      <img src="../../image/global/isSold.png" alt="img">
    </div>
    <lazy-img
      class="lazy-img"
      :src="src"
      alt
      :background="background"
      :width="width"
      :height="height"
    ></lazy-img>
  </div>
</template>

<script>
import lazyImg from "./lazy-img.vue";

export default {
  props: {
    width: String,
    height: String,
    src: String,
    background: {
      type: String,
      default: "#ffffff"
    },
    isSold: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    customStyle() {
      return [
        { width: this.width },
        { height: this.height },
        { background: this.background }
      ];
    },
    soldImgSize() {
      if(this.customStyle[0].width == '28vw') {
        return 'smallSoldImg'
      } else {
        return 'bigSoldImg'
      }
    }
  },
  components: {
    lazyImg
  }
};
</script>

<style lang="less" scoped>

.isSoldOut_container {
  position: relative;
  margin: 0 auto;

  /deep/ .lazy-img .lazy-img-wrap .target-img {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .smallSoldImg {
    position: absolute;
    width: 16.8vw;
    height: 16.8vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bigSoldImg {
    position: absolute;
    width: 26.4vw;
    height: 26.4vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .lazy-img {
    position: absolute;
  }
}
</style>

